export default "__VITE_ASSET__DhT3eWUa__"